import { VStack } from '@chakra-ui/react';
import { ChangeEvent } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { Checkbox, Typography, Show } from 'shared';

import { SessionsFormLateStatus } from 'features/sessions/components/Form/SessionInfo/LateStatus';
import { SESSION_ATTENDANCE_STATUS } from 'features/sessions/config';

export const SessionsFormNoShowCheckbox = () => {
  const { setValue, register } = useFormContext();
  const attendance = useWatch({
    name: 'attendance',
  });

  const onNoShowStatusChange = (event: ChangeEvent<HTMLInputElement>) => {
    const attended = event.target.checked;

    setValue(
      'attendance',
      attended
        ? SESSION_ATTENDANCE_STATUS.NO_SHOW
        : SESSION_ATTENDANCE_STATUS.ATTENDED,
      { shouldDirty: true }
    );
    setValue('isNoShow', attended, { shouldDirty: true });
  };

  return (
    <Show
      when={
        attendance === SESSION_ATTENDANCE_STATUS.NO_SHOW ||
        attendance === SESSION_ATTENDANCE_STATUS.ATTENDED
      }
    >
      <VStack alignItems="flex-start" gap={0}>
        <Checkbox
          data-testid="session-no-show-checkbox"
          {...register('isNoShow')}
          onChange={onNoShowStatusChange}
        >
          <Typography dataTestid="session-no-show-label">No-show</Typography>
        </Checkbox>
        <SessionsFormLateStatus />
      </VStack>
    </Show>
  );
};
